import React, { useContext, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'formlabs-web-components/Form';

import { getCountries } from './SelectOptions';
import { sortWithLocale } from '../../../utils';
import CountryContext from '../../../context/country';

const CountrySelect = ({ withFavorites, ...props }) => {
  const { t } = useTranslation();
  const locale = useContext(CountryContext);
  const { allowedCountries, language } = locale;

  return (
    <Select {...props}>
      <option value="">– {t('Select')} –</option>
      {withFavorites && (
        <Fragment>
          {allowedCountries.map(allowedCountry => (
            <option key={allowedCountry.iso} value={allowedCountry.name}>
              {t(allowedCountry.name)}
            </option>
          ))}
          <option key="none" value="" disabled>
            -------------
          </option>
        </Fragment>
      )}
      {sortWithLocale(getCountries(t), language).map(country => (
        <option key={country.value} value={country.value}>
          {country.text}
        </option>
      ))}
    </Select>
  );
};

CountrySelect.defaultProps = { defaultValue: '' };
export default CountrySelect;
